<template>
    <div class="mtb-presentation-dropdown-modal" id="outside_modal">
        <div class="mtb-presentation-dropdown-window" id="in_modal">
            <input type="checkbox" id="nextPatientOnCarousel" @change="toggleNextPatient" :checked="config.nextPatientOnCarousel">
            <label for="nextPatientOnCarousel">Auto-flip patients</label>
            <input type="checkbox" id="firstPageOnSwitch" @change="toggleFirstPage" :checked="config.firstPageOnSwitch">
            <label for="nextPatientOnCarousel">Jump to first page</label>
            <label for="deviceName" v-if="props.websocket !== null">ID:</label>
            <input type="text" v-if="props.websocket !== null" id="deviceName" @change="changeDeviceName" v-model="device_name"/>
        </div>
    </div>
</template>

<script setup lang="js">
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const config = computed(() => store.state.presentation_config);

/**
 * Has one emit:
 * 
 * @param close-modal (emit) - Tells the parent to close this modal
 */
const emit = defineEmits(['close-modal']);

const props = defineProps({
    websocket: WebSocket|null,
})

/**
 * On mounting, sets values for inside and outside the modal and stores them.
 */
onMounted(() => {
    initialized.value = false;
    if(document.getElementById("in_modal") && document.getElementById("in_modal") != undefined) {
        in_modal.value = document.getElementById("in_modal")
    }
    if(document.getElementById("outside_modal") && document.getElementById("outside_modal") != undefined) {
        outside_modal.value = document.getElementById("outside_modal")
    }
    initialized.value = true;
    if (localStorage.getItem("onkopus_device_name") !== null)
        device_name.value = localStorage.getItem("onkopus_device_name");
})

/**
 * Shows the modal if a user clicks inside the modal.
 * Closes it if a user clicks outside the modal.
 */
window.onclick = ((e) => {
    if (!initialized) {
        return;
    }
    if ((!in_modal.value || !outside_modal.value) || (e.target == outside_modal.value && e.target != in_modal.value)) {
        emit('close-modal')
    }
});

/**
 * Updates the store to be in line with user-set checkbox value for the 'nextPatientOnCarousel' option.
 * This option controls whether to switch to the next patient by clicking the right arrow on the last slide or not.
 * (same for the left arrow on the first slide)
 */
const toggleNextPatient = () => {
    let checkbox_state = document.getElementById('nextPatientOnCarousel').checked;
    store.dispatch('setPresentationConfig_NP', checkbox_state);
}

/**
 * Updates the store to be in line with user-set checkbox value for the 'firstPageOnSwitch' option.
 * This option controls whether the presentation jumps to slide 0 if a new patient is selected or not.
 * By default, this is false.
 */
const toggleFirstPage = () => {
    let checkbox_state = document.getElementById('firstPageOnSwitch').checked;
    store.dispatch('setPresentationConfig_FP', checkbox_state);
}

/**
 * Changes the presentation device name based on what the user entered in the according text field.
 */
const changeDeviceName = () => {
    try {
        let new_name = document.getElementById("deviceName")?.value;
        localStorage.setItem("onkopus_device_name", new_name);
        props.websocket?.send(JSON.stringify({codeword: 'change-name', id: new_name}))
    }
    catch (error) {
        console.error('Encountered an error while trying to change device name.');
    }
}

const in_modal=ref();
const outside_modal=ref();
const initialized=ref(false);
const device_name = ref('');
</script>

<style>

.mtb-presentation-dropdown-modal {
    position: absolute;
    z-index: 30;
    top: 3em;
    left: 0px;
    width: 100%;
    height: 100%;
}

.mtb-presentation-dropdown-window {
    position: fixed;
    z-index: 40;
    top: 30%;
    right: 2rem;
    width: fit-content;
    height: fit-content;
    min-width: 10rem;
    min-height: 5rem;
    max-width: 20rem;
    background-color: #e3e3e3;
    border: #b3b3b3 solid 1px;
    border-radius: 16px;
    padding: 4px;
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: 1fr 5fr;
    justify-items: center;
    align-items: center;
}

input[type="checkbox"] {
    accent-color: var(--default-blue);
}

@media (max-width: 1366px) {

.mtb-presentation-dropdown-window {
    font-size: 0.75rem;
    min-width: 6rem;
    min-height: 4rem;
}

@media (max-width: 900px) {
    
.mtb-presentation-dropdown-window {
    font-size: 0.65rem;
    min-width: 5rem;
    min-height: 3rem;
}

}

}

</style>

<style scoped>

#deviceName {
    background-color: white;
    accent-color: var(--default-blue);
    border-radius: 10px;
    padding-left: 10px;
    width: 80%;
    margin: 4px 0 4px;
}

</style>
